
document.addEventListener('DOMContentLoaded', function () {
    var win_width = $(window).width();
    var win_height = $(window).height();
    var scrollmagic_offset = (win_height / 800) * 400;

    var arr2 = [];
    for (var i = 1; i < 25; i++) {
        arr2.push('//cdn.shopify.com/s/files/1/2548/9034/files/nphp_' + i + '.png?v=1670810120');
    }
    var images2 = arr2;

    // TweenMax can tween any property of any object. We use this object to cycle through the array
    var obj2 = { curImg: 0 };

    var controller_sec6 = new ScrollMagic.Controller();
    var sec6_timeline = new TimelineMax();
    sec6_timeline

        .add([
            TweenMax.to(obj2, 10, {
                curImg: images2.length - 1, // animate propery curImg to number of images
                roundProps: 'curImg', // only integers so it can be used as an array index
                repeat: 0, // repeat 3 times
                immediateRender: true, // load first image automatically
                ease: Linear.easeNone, // show every image the same ammount of time
                onUpdate: function () {
                    $('#ct-2-3-pro').attr('src', images2[obj2.curImg]); // set the image source
                },
            }),
        ])

        .add([TweenMax.to('.np-sec2-p4-content', 3, { opacity: '1' })], '-=4')
        .add([
            TweenMax.to('.np-carry-bag', 0.5, { css: { display: 'block' } }),
            TweenMax.to('.np-carry-bag', 8, { opacity: '1', delay: 8 }),
            TweenMax.to('.np-carry-bag', 8, { className: '+=carry-up-bag', delay: 8 }),
            TweenMax.to('#ct-2-3-pro', 5, { opacity: '0', delay: 8 }),
        ]);

    new ScrollMagic.Scene({ triggerElement: '#ct-6hid', duration: 1000, offset: scrollmagic_offset })
        .setTween(sec6_timeline)
        .setPin('#ct-6hid')
        .addTo(controller_sec6);
});
